module.exports = {
  "general.days": "Tage",
  "general.day": "Tag",
  "general.select-days": "Tage auswählen",
  "general.select-day": "Tag auswählen",
  "general.selected-days": "Ausgewählte Tage",
  "general.selected-day": "Ausgewählter Tag",
  "general.date": "Datum",
  "general.continue": "Weitermachen",
  "general.country": "Land",
  "general.reservation": "Reservierung",
  "general.guest": "Gast",
  "general.guests": "Gäste",
  "general.guests.one": "1 Gast",
  "general.guests.other": "{0} Gäste",
  "general.single.beds.one": "1 Single bed",
  "general.single.beds.other": "{0} Single beds",
  "general.double.beds.one": "1 Double bed",
  "general.double.beds.other": "{0} Double beds",
  "general.guidelines": "Allgemeine Richtlinien",
  "general.interests": "Interessen",
  "general.interests_hostz": "Anreiseinfo",
  "general.interests_offgrid": "Extras",
  "general.payments": "Zahlungen",
  "general.summary": "Zusammenfassung",
  "general.summary_offgrid": "Überblick",
  "general.back": "Zurück",
  "general.buy": "Kaufe",
  "general.next": "Nächste",
  "general.next_offgrid": "Weiter",
  "general.confirm": "Bestätigen",
  "general.cancel": "Abbrechen",
  "general.close": "Schließen",
  "general.save": "Speichern",
  "general.go-back": "Geh zurück",
  "general.stay": "Dein Aufenthalt",
  "general.identify-using-qr": "Identifizieren Sie mich mit QR",
  "general.identify-using-code": "Identifizieren Sie mich mithilfe des Codes",
  "general.identify-welcome": "Willkommen",
  "general.identify-welcome-phrase": "Bitte schließen Sie den Vor-Check-in ab, damit wir alles für Ihre Ankunft bereithalten können.",
  "general.identify-welcome-phrase-offgrid": "Bitte schließe zeitnah deinen Online-Check-in ab. Die Anreiseinfos erhältst du einen Tag vor deiner Anreise.",

  "general.identify-screen.title": "Zugriff auf Ihren digitalen Assistenten für den Aufenthalt:",
  "general.identify-screen.subtitle": "Mit Ihrem Buchungscode oder Ihren Daten, wenn Sie bereits im Hotel sind",
  "general.identify-screen.subtitle-1": "Füllen Sie die Angaben aus, um fortzufahren",
  "general.identify-screen.subtitle-2": "Bitte füllen Sie die folgenden Informationen aus, um fortzufahren",
  "general.identify-screen.button-code": "Ich habe einen Buchungscode",
  "general.identify-screen.button-data": "Ich bin bereits im Hotel",
  "general.identify-screen.button-identify": "Weiter",
  "general.identify-screen.button-return-code": "Zurück zur Identifikation mit Buchungscode",
  "general.identify-screen.button-return-data": "Zurück zur Identifikation mit Reservierungsdaten",
  "general.identify-screen.error-code": "Wir konnten den angegebenen Buchungscode nicht finden. Bitte versuchen Sie es erneut!",
  "general.identify-screen.error-data": "Wir konnten die Reservierung mit den angegebenen Daten nicht finden. Bitte versuchen Sie es erneut!",
  "general.identify-screen.title-hostz": "Melden Sie sich jetzt an und greifen Sie auf das Gästeportal zu:",
  "general.active": "Aktiv",
  "general.inactive": "Inaktiv",
  "general.go-to-detail": "Gehen Sie zu Detail",
  "general.go_to_website": "Mehr erfahren",
  "general.go-to-my-stay": "Gehe zu Meinem Aufenthalt",
  "general.price": "Preis",
  "general.report": "Bericht",
  "general.edit": "Bearbeiten",
  "general.checkin_edit": "Check-in-Daten bearbeiten",
  "general.experiences": "Erlebnisse",
  "general.request": "Anfrage",
  "general.send": "Senden",
  "general.detail": "Detail",
  "general.no-charge": "Frei",
  "general.yes": "JA",
  "general.no": "NEIN",
  "general.dateformat": "dd-MM-yyyy",
  "general.short-dateformat": "dd-MM",
  "general.chat": "Chat",
  "general.checkout": "Check-out",
  "general.services": "Dienstleistungen",
  "general.equipment": "Ausrüstung",
  "general.features": "Merkmale",
  "general.remove": "Entfernen",
  "general.upload": "Hochladen",
  "general.upload-file": "Datei hochladen",
  "general.menu": "Speisekarten",
  "general.start.checkin": "Check-in beginnen",
  "general.placeOrder": "Bestellung schicken",
  "general.updateOrder": "Bestellung schicken",
  "general.clear": "Löschen",
  "general.please": "Bitte",
  "general.touch": "Bitte berühren ",
  "general.from": "Von",
  "general.to": "Bis",
  "general.duration": "Dauer",
  "general.total": "Gesamtbetrag",
  "general.today": "Heute",
  "general.yesterday": "Gestern",
  "general.tomorrow": "Morgen",
  "general.balance": "Kontostand",
  "general.hour": "Uhrzeit",
  "general.time": "Uhrzeit",
  "general.qty": "Menge",
  "general.reserve": "Reservieren",
  "general.key_explanation": "Dieser Schlüssel wird vom Concierge bereitgestellt.",
  "general.selected": "Ausgewählt",
  "general.time-format": " Std",
  "general.select-date": "Bitte buchen Sie hier Ihren Zeitraum.",
  "general.no-schedule-available": "Leider sind keine Termine verfügbar.",
  "general.fields_required": "Erforderliche Felder",
  "general.about": "Über",
  "general.type_message": "Schreibe eine Nachricht...",
  "general.items.qty": "Artikelmenge",
  "general.add-to-home-screen-text": "Du kannst den Travel Guide zu deinem Startbildschirm hinzufügen, um schnell darauf zugreifen zu können.",
  "general.add-to-home-screen-button": "Zum Startbildschirm hinzufügen",
  "general.hs": ":00",
  "general.hs-abrev": ".",
  "general.min": "Min.",
  "general.select_option": "Wählen Sie eine Option...",
  "general.customization": "Konfigurieren Sie Ihr Extra...",
  "general.accept": "Akzeptieren",
  "Hotel amenities and services": "ANNEHMLICHKEITEN UND DIENSTLEISTUNGEN DES HOTELS",
  "In order to enjoy our hotel more, we have the following precautions against covid": "Damit Sie unser Hotel bedenkenlos genießen können, haben wir die folgenden Vorkehrungen gegen Covid getroffen",
  "hotel.website": "Webseite",
  "hotel.phones": "Telefon",
  "hotel.address": "Adresse",
  "hotel.contact-us": "Kontaktiere uns",
  "hotel.social-networks": "Soziale Netzwerke",
  "hotel.please-feel":
    "Sie können uns gerne kontaktieren! Kontaktinformationen unten.",
  "hotel.location": "Standort",
  "hotel.conditioning-air-in-common-spaces":
    "Konditionierung der Luft in Gemeinschaftsräumen",
  "hotel.parking": "Parken",
  "hotel.free-parking": "Gratis Parkplätze",
  "hotel.pay-parking": "Kostenpflichtiges Parken",
  "hotel.bar": "Bar",
  "hotel.aesthetic-center": "Ästhetisches Zentrum",
  "hotel.kids-club": "Kinderclub",
  "hotel.luggage-storage": "Gepäcklagerung",
  "hotel.breakfast": "Frühstück",
  "hotel.breakfast-buffet": "Frühstücksbuffet",
  "hotel.smoke-free-space": "Rauchfreier Raum",
  "hotel.fitness-center": "Fitness center",
  "hotel.gay-friendly": "Schwulenfreundlich",
  "hotel.hydromassage": "Hydromassage",
  "hotel.gardens": "Gardens",
  "hotel.masseuse-available": "Masseurin verfügbar",
  "hotel.water-park": "Wasserpark",
  "hotel.hairdressing": "Friseur",
  "hotel.bilingual-staff-english-spanish":
    "Zweisprachiges Personal (Englisch/Spanisch)",
  "hotel.pet-friendly": "Haustierfreundlich",
  "hotel.pool": "Schwimmbad",
  "hotel.smoking-points": "Raucherstellen",
  "hotel.reception-24-hs": "Rezeption rund um die Uhr besetzt",
  "hotel.restaurant": "Restaurant",
  "hotel.restaurant-to-the-card": "Restaurant zur Karte",
  "hotel.theme-restaurant": "Themenrestaurant",
  "hotel.congress-hall": "Kongresshalle",
  "hotel.meeting-room": "Besprechungszimmer",
  "hotel.sauna": "Sauna",
  "hotel.laundry-service": "Wäscherei-Service",
  "hotel.babycare-service": "Babybetreuungsdienst",
  "hotel.spa": "Spa",
  "hotel.theater": "Theater",
  "hotel.terraces": "Terrassen",
  "hotel.souvenir-shop": "Souvenirgeschäft",
  "hotel.airport-transfer": "Flughafentransfers auf Anfrage",
  "hotel.covid.protected-medical-area": "Geschützter medizinischer Bereich",
  "hotel.covid.virtual-check-in-out": "Virtueller Check-in/Out",
  "hotel.covid.temperature-check": "Temperaturprüfung",
  "hotel.covid.first-aid-kit-available": "Erste-Hilfe-Kasten verfügbar",
  "hotel.covid.separation-screens-for-personnel":
    "Trennbildschirm für Personal",
  "hotel.covid.contactless-payment-available": "Kontaktloses Bezahlen möglich",
  "hotel.covid.sanitizers-in-common-areas":
    "Desinfektionsmittel in öffentlichen Bereichen",
  "hotel.covid.use-of-specific-cleaning-articles-for-covid":
    "Verwendung spezieller Reinigungsartikel für Covid",
  "checkin.checkin.preparing-title": "Vorbereitung Ihres Check-ins",
  "checkin.checkin.preparing-text": "Bitte schließen Sie dieses Fenster nicht oder aktualisieren Sie es nicht.",
  "checkin.status": "Status",
  "checkin.status-pending": "Ausstehend",
  "checkin.status-observed": "Handlung erforderlich",
  "checkin.status-to_validate": "Wird bearbeitet",

  "checkin.status-to_validate-text--":
    "<b>Das ist alles für den Moment!</b> Wir werden die Angaben prüfen und Ihnen in Kürze eine Bestätigungsnachricht senden! Grüße!",
  "checkin.status-to_validate-text":
    "<b>Das war's für den Moment!</b> Vielen Dank für das Ausfüllen des Web-Check-ins. Mit freundlichen Grüßen",

  "checkin.status-in_progress": "Im Gange",
  "checkin.status-accepted": "Akzeptiert",
  "checkin.status-accepted-text":
    "<b>Ihr Check-in wurde erfolgreich abgeschlossen!</b> Wir freuen uns auf Sie! Gute Reise!",
  "checkin.status-no_show": "Keine Show",
  "checkin.status-no_show-text":
    "Bitte kontaktieren Sie uns über die Chat-Schaltfläche unten, falls Sie Ihre ursprüngliche Reservierung verschieben möchten. Hoffe dich bald zu sehen!",
  "checkin.status-canceled": "Abgesagt",
  "checkin.status-canceled-text":
    "Ihre Reservierung wurde storniert. Bitte kontaktieren Sie uns über die Chat-Schaltfläche unten, wenn Sie der Meinung sind, dass es sich hierbei um einen Fehler handelt oder wenn Sie ihn ändern möchten. Danke!",
  "checkin.status-done": "Abgereist",
  "checkin.status-done-text":
    "Ihr Aufenthalt ist abgeschlossen! Kontaktieren Sie uns über den Chat-Button unten. Danke schön!",
  "checkin.please-complete":
    "Bitte füllen Sie dieses Formular aus, um den Check-in-Vorgang abzuschließen. Wenn Sie bereits einen Check-in-Code haben, geben Sie diesen ein",
  "checkin.not-forget":
    "Vergessen Sie nicht, alle Personen hinzuzufügen, die mit Ihnen reisen. Sie können ihre Informationen eingeben, nachdem Sie dieses Formular ausgefüllt haben.",
  "checkin.initiated": "Mein Check-in",
  "checkin.stay": "Dein Aufenthalt",
  "checkin.in": "Beitrittsdatum",
  "checkin.out": "Abreisedatum",
  "checkin.travel-type": "Art der Reise",
  "checkin.inputs.select": "Wählen...",
  "checkin.inputs.dni-number": "ID-Nummer",
  "checkin.inputs.dni-number-offgrid": "Ausweisnummer",
  "checkin.inputs.email": "E-Mail",
  "checkin.inputs.dni-issue-date": "Ausstellungsdatum",
  "checkin.inputs.dniIssueDate": "Ausstellungsdatum",
  "checkin.inputs.dni-issue-date-offgrid": "Gültig bis",
  "checkin.inputs.dniIssueDate-offgrid": "Gültig bis",
  "checkin.inputs.dniIssueDate-simplex": "Gültig bis",
  "checkin.inputs.name": "Name",
  "checkin.inputs.travelType": "Reiseart",
  "checkin.inputs.surname": "Nachname",
  "checkin.inputs.gender": "Geschlecht...",
  "checkin.inputs.gender.male": "Männlich",
  "checkin.inputs.gender.female": "Weiblich",
  "checkin.inputs.gender.other": "Andere",
  "checkin.inputs.date-of-birth": "Geburtsdatum",
  "checkin.inputs.address": "Straße und Hausnummer",
  "checkin.inputs.postal-code": "PLZ",
  "checkin.inputs.nationality": "Staatsangehörigkeit",
  "checkin.inputs.residence": "Land",
  "checkin.inputs.country_of_residence": "Wohnortland",
  "checkin.inputs.city": "Stadt",
  "checkin.inputs.dniType": "Ausweistyp",
  "checkin.inputs.zipCode": "Postleitzahl",
  "checkin.inputs.dni": "Ausweisnummer",
  "checkin.inputs.birthday": "Geburtsdatum",
  "checkin.inputs.phone": "Telefon",
  "checkin.inputs.passenger": "Passagierdaten",
  "checkin.inputs.photos_selfie": "Selfie",  
  "checkin.inputs.photos_dniFront": "Vorder",
  "checkin.inputs.photos_dniBack": "Rückseite",

  "checkin.inputs.entryTime": "Ankunftszeit",
  "checkin.inputs.arrivalMode": "Wie reisen Sie an?",
  "checkin.inputs.extraData_qtyAdults": "Erwachsene",
  "checkin.inputs.extraData_qtyChild": "Kind",
  "checkin.inputs.extraData_qtyBabies": "Säuglinge",
  "checkin.company-information": "Unternehmensinformationen",
  "checkin.company-information-text": "Bitte geben Sie die Unternehmensinformationen ein.",
  "checkin.company-name": "Name",
  "checkin.company-name-placeholder": "Geben Sie den Namen ein",
  "checkin.company-address": "Adresse",
  "checkin.company-address-placeholder": "Geben Sie die Adresse ein",
  "checkin.company-country": "Land",
  "checkin.company-country-placeholder": "Wählen Sie das Land",
  "checkin.company-zip-code": "Postleitzahl",
  "checkin.company-zip-code-placeholder": "Geben Sie die Postleitzahl ein",
  "checkin.company-city": "Stadt",
  "checkin.company-city-placeholder": "Geben Sie die Stadt ein",
  "checkin.identificate": "Identität bestätigen",

  "checkin.passenger": "Gast",
  "checkin.passengers": "Gäste",
  "checkin.passengers-list": "Gästeliste",
  "checkin.passengers-error-incomplete":
    "Bitte füllen Sie die Gästeinformationen aus",
  "checkin.add-passenger": "Gast hinzufügen",
  "checkin.save-checkin": "Check-in speichern",
  "checkin.save-changes": "Änderungen speichern",
  "checkin.update-info": "Updateinformation",
  "checkin.reservation-data": "Reservierungsinformationen",
  "checkin.request-photos":
    "Bitte stelle sicher, dass die Bilder scharf und lesbar sind. Du kannst die Bilder nach der Aufnahme zuschneiden und die Größe anpassen.",
  "checkin.reviewing":
    "Danke schön! Wir prüfen Ihre Anfrage. Sie erhalten in Kürze eine Benachrichtigung über den <b>Status Ihres Check-ins</b>.",
  "checkin.remember-can":
    "Denken Sie daran, dass Sie Ihre Check-in Informationen weiterhin ändern können",
  "checkin.can-see":
    "Sie können den Check-in-Verlauf einsehen und unten einen Kommentar hinzufügen.",
  "checkin.please-read-to-change":
    "Bitte lesen Sie die folgenden Informationen und nehmen Sie die erforderlichen Änderungen vor, um fortzufahren.",
  "checkin.modify": "Ändern",
  "checkin.edit-data": "Daten bearbeiten",
  "checkin.accept": "Akzeptieren",
  "checkin.dni-front": "Vorder",
  "checkin.dni-back": "Rückseite",
  "checkin.camera": "Kamera",
  "checkin.date-of-birth": "Geburtsdatum",
  "checkin.age": "Alter",
  "checkin.add-comment": "Einen Kommentar hinzufügen",
  "checkin.me": "Mich",
  "checkin.accepted-text":
    "<b>Ihr Check-in wurde angenommen!</b> Wir freuen uns darauf, dich zu sehen! Denken Sie daran, dass Sie uns im Kommentarbereich unten alles fragen können. Gute Reise!",
  "checkin.canceled-text":
    "<b>Ihr Check-in wurde storniert.</b> Bitte lesen Sie die Kommentare unten, um zu erfahren, wie es weitergeht. Danke!",
  "checkin.new-checkin": "Neuer Check-in",
  "checkin.use-button-to-add-guest":
    "Über die Schaltfläche unten können Sie weitere Gäste hinzufügen.",
  "checkin.identified": "Identifizierter Check-in!",
  "checkin.identify-error":
    "Wir konnten den angegebenen Reservierungscode nicht finden, bitte versuchen Sie es erneut!",
  "checkin.time-of-arrival": "Ankunftszeit",
  "checkin.time-of-arrival-text":
    "Gerne teile uns deine voraussichtliche Ankunftszeit mit.",
  "checkin.time-of-arrival-text2": "Deine Wohnung steht ab {0} Uhr bereit.",
  "checkin.time-of-arrival-text2-hostz": "Ihr Apartment steht ab {0} Uhr zur Verfügung.",
  "checkin.time-of-arrival-text2-offgrid": "Deine Cabin steht ab {0} Uhr bereit.",
  "checkin.time-of-arrival-early-checkin":
    "Fordern Sie einen <b>frühen Check-in</b> <span class='text-muted'>(je nach Verfügbarkeit)</span>",
  "checkin.e-mail": "E-Mail",
  "checkin.phone": "Telefon",
  "checkin.guest-data": "Gastdaten",
  "checkin.guest-data-text":
    "Bitte ergänze alle fehlenden Informationen, um deinen Online Check-in Vorgang abzuschließen.",
  "checkin.guest-complete-later":
    "Ich vervollständige die Angaben später.",
  "checkin.id-type.id": "AUSWEIS",
  "checkin.id-type.passport": "REISEPASS",
  "checkin.id-type.nif": "NIF",
  "checkin.id-type.nie": "NIE",
  "checkin.type-of-travel": "Art der Reise",
  "checkin.type-of-travel-text":
    "Dein Erlebnis wird ganz auf deine / eure Bedürfnisse abgestimmt.",
  "checkin.travel-type.couple": "Paar",
  "checkin.travel-type.congress": "Kongress",
  "checkin.travel-type.family": "Familienausflug",
  "checkin.travel-type.business": "Geschäft",
  "checkin.travel-type.event": "Ereignis",
  "checkin.travel-type.friends": "Freundesreise",
  "checkin.travel-type.relaxing": "Entspannend",
  "checkin.travel-type.party": "Partyreisen",
  "checkin.travel-type.single_traveler": "Einzelreisender",
  "checkin.travel-type.leisure": "Urlaubsreise",
  "checkin.room-preferences": "Raumpräferenzen",
  "checkin.room-preferences-text":
    "Haben Sie Vorlieben für Ihr Zimmer? <br />Lassen Sie es uns hier wissen:",
  "checkin.room-preferences.close-to-elevator": "In der Nähe des Aufzugs",
  "checkin.room-preferences.far-from-elevator": "Weit weg vom Aufzug",
  "checkin.room-preferences.wheelchair-accessible": "Behindertengerecht",
  "checkin.room-preferences.lower-floor": "Zimmer auf einer unteren Etage",
  "checkin.room-preferences.higher-floor": "Zimmer auf einer höheren Etage",
  "checkin.take-care-environment":
    "Möchten Sie mithelfen, die Umwelt zu schonen?",
  "checkin.take-care-environment-text":
    "Kleine Dinge können Ihren ökologischen Fußabdruck während Ihres Aufenthalts deutlich reduzieren.",
  "checkin.take-care-environment.housekeeping-frequency":
    "Häufigkeit der Haushaltsführung",
  "checkin.take-care-environment.housekeeping-frequency.everyday": "Täglich",
  "checkin.take-care-environment.housekeeping-frequency.every-other-day":
    "Jeder andere Tag",
  "checkin.take-care-environment.housekeeping-frequency.do-not-clean-my-room":
    "Reinige mein Zimmer nicht",
  "checkin.take-care-environment.towell-replacement-frequency":
    "Häufigkeit des Austauschs von Handtüchern",
  "checkin.take-care-environment.towell-replacement-frequency.do-not-change":
    "Wechseln Sie die Handtücher nicht",
  "checkin.take-care-environment.towell-replacement-frequency.everyday":
    "Täglich",
  "checkin.take-care-environment.towell-replacement-frequency.every-other-day":
    "Jeder andere Tag",
  "checkin.restaurant-reservation":
    "Ich bin an einer Reservierung für Ihr/e <b>Restaurant/s</b> interessiert",
  "checkin.comments": "Kommentare",
  "checkin.comments-text":
    "Bitte teile uns mit, wie wir deinen Aufenthalt verbessern können.",
  "checkin.review-the-summary":
    'Bitte überprüfe die Zusammenfassung deines Online Check-ins. Falls etwas nicht stimmt, kannst du zurückgehen und deine Angaben bearbeiten. Wenn alles passt, klicke unten auf <b>"Bestätigen"</b>.',
  "checkin.reservation-code": "Reservierungscode",
  "checkin.in-out": "Anreise / Abreise",
  "checkin.primary-guest": "Hauptgast",
  "checkin.guests-text": "Wir benötigen diese Informationen, um die beste Bettenkonfiguration für Ihren Aufenthalt zu bestimmen und Ihren Komfort zu gewährleisten.<br /><br /><small>Erwachsener (+15 Jahre) / Kind (3-14 Jahre) / Baby (0-2 Jahre)</small>",
  "checkin.arrivalMode": "Art der Anreise",
  "checkin.arrivalMode-hostz": "Wie reisen Sie an?",
  "checkin.arrivalMode-text": "Bitte wähle das Transportmittel, mit dem du anreist.",
  "checkin.arrivalMode.airplane": "Flugzeug",
  "checkin.arrivalMode.public_transportation": "Öffentliche Verkehrsmittel (Bus/Zug)",
  "checkin.arrivalMode.train": "Zug",
  "checkin.arrivalMode.bus": "Bus",
  "checkin.arrivalMode.car": "Auto",
  "checkin.arrivalMode.other": "Andere",
  "checkin.adult-s": "Erwachsene(r)",
  "checkin.adults": "Erwachsene",
  "checkin.adult": "Erwachsene",
  "checkin.short-room": "Zimmer",
  "checkin.room": "Zimmer",
  "checkin.do-not-disturb": "Bitte nicht stören",
  "checkin.select-door-open": "Bitte wählen Sie aus, welche Tür Sie öffnen möchten...",
  "checkin.select-door-open-hostz": "Klicken Sie auf die Tür, die Sie öffnen möchten",
  "checkin.select-door-open-themyde": "Wählen Sie unten eine Tür aus und wischen Sie, um sie zu öffnen.",
  "checkin.select-photo-source-to": "Wählen Sie die Fotoquelle aus ",
  "checkin.use-camera": "Verwenden Sie die Kamera",
  "checkin.selfie.preview-title": "Selfie",
  "checkin.selfie.preview-text": "Schneiden Sie das Bild zu, um Ihr Gesicht zu zentrieren.",
  "checkin.dniFront.preview-title": "Vorder",
  "checkin.dniFront.preview-text": "Schneiden Sie das Bild zu, um Ihr Dokument richtig zu zentrieren.",
  "checkin.dniBack.preview-title": "Rückseite",
  "checkin.dniBack.preview-text": "Schneiden Sie das Bild zu, um Ihr Dokument richtig zu zentrieren.",
  "checkin.redirecting": "Weiterleitung in {0} Sekunden...",
  "checkin.camera.repeat": "Wiederholen",
  "checkin.camera.crop": "Schneiden",
  "checkin.camera.use-photo": "Verwenden Sie Foto",
  "checkin.reservation-conditions-text": "Die Geschäftsführung übernimmt keine Haftung für in den Zimmern gelassene Wertgegenstände.<br /><br /><b>Abreisezeit ist bis 11:00 Uhr morgens.</b><br /><br /><span class='text-danger font-weight-bold'>Das Rauchen in allen Gästezimmern sowie öffentlichen Bereichen ist nicht gestattet.</span><br />Bitte beachten Sie, dass das Rauchen nur auf der Straße vor dem Haupteingang erlaubt ist. Sollten Sie trotzdem im Zimmer rauchen, wir eine Reinigungsgebühr von Euro 250,00 verrechnet.<br /><br /><small>Die oben genannten Angaben werden datenmäßig erfasst.</small>",
  "checkin.reservation-conditions-text-offgrid": "<b>Check-in:</b> ab 15 Uhr<br/><b>Check-out:</b> bis 11 Uhr<br/><ul><li>Rauchen ist in allen unseren Cabins verboten.</li><li>Bitte beachte, dass nur angemeldete Gäste sich in der Cabin aufhalten und übernachten dürfen.Die maximale Gästeanzahl beträgt 2 Personen.</li><li>Bitte melde Schäden und Mängel sofort über „Schadensmeldung“ in deinem Guide oder kontaktiere uns über unsere Hotline: +49 30 54806375.</li><li>Die Anreise und Nutzung unserer Offgrid-Unterkünfte erfolgen auf eigene Gefahr; wir haften nicht für witterungsbedingte Einschränkungen, Unfälle oder Schäden, außer bei grober Fahrlässigkeit oder Vorsatz. Detaillierte Regelungen findest du in unseren AGB.</li></ul><br/>Eine Übersicht unserer Cabin Regeln findest du hier in deinem Travel Guide unter “Your Cabin” -> “Cabin Regeln”.",

  "checkin.signature": "Unterschrift",
  "checkin.please-sign-here": "Hier tippen zum Unterschreiben",
  "checkin.please-sign-below": "Bitte unterschreiben Sie unten",
  "checkin.confirm": "Bestätigen",
  "checkin.newsletter": "Newsletter",
  "checkin.newsletter-optin": "Ich möchte Hotel-Neuigkeiten und Angebote per E-Mail erhalten",
  "checkin.gdpr-text1": "Mit meiner Unterschrift unten gebe ich meine Zustimmung zur Verarbeitung meiner persönlichen Daten gemäß der",
  "checkin.gdpr-text2": ". Ich verstehe, dass ich meine Einwilligung jederzeit widerrufen kann.",
  "checkin.gdpr-text-nexo": "und das",

  "checkin.gdpr-text1-costa": "By signing below, I consent to the processing of my personal data as outlined in the",
  "checkin.gdpr-text2-costa": ", and I declare that I am not a tax resident in the Argentine Republic, as per ",
  "checkin.gdpr-text-nexo-costa": ", and understand that I can withdraw my consent at any time. I also confirm that I have read and accept the ",
  "checkin.gdpr-text3-costa": "I declare that my stay in Argentina is for tourism and does not exceed the legally allowed period, in order to request a VAT refund under Law N° 3971 (AFIP) and Resolution N° 566.",
  "checkin.gdpr-button-2-popup": "I declare that my stay in Argentina does not exceed the stablished maximum term, according to the current immigration legislation and my reason to visit Argentina is for tourism only.<br />The present AFFIDAVIT serves for the purposes of issuing the VAT exemption request, due to the General Resolution N° 3971(AFIP) and Resolution N°566(tourism)",

  "checkin.gdpr-text1-hostz": "Durch meine Unterschrift unten erkläre ich mich mit der Verarbeitung meiner persönlichen Daten gemäß den",
  "checkin.gdpr-text2-hostz": " zu halten.",
  "checkin.gdpr-text-nexo-hostz": " einverstanden und verstehe, dass ich meine Zustimmung jederzeit widerrufen kann.<br/><br/>Ich bestätige und stimme zu, mich an die ",
  "checkin.gdpr-text1-simplex": "Durch meine Unterschrift unten erkläre ich mich mit der Verarbeitung meiner persönlichen Daten gemäß den",
  "checkin.gdpr-text2-simplex": " zu halten.",
  "checkin.gdpr-text-nexo-simplex": " einverstanden und verstehe, dass ich meine Zustimmung jederzeit widerrufen kann.<br/><br/>Ich bestätige und stimme zu, mich an die ",

  "checkin.gdpr-text1-offgrid": "Mit meiner Unterschrift stimme ich der Verarbeitung und Nutzung meiner Daten gemäß der",
  "checkin.gdpr-text2-offgrid": " von Offgrid Mindful Cabins.",
  "checkin.gdpr-text-nexo-offgrid": " zu und akzeptiere die ",

  "checkin.gdpr-button": "Datenschutzrichtlinie",
  "checkin.gdpr-button-1": "Hotelordnung",
  "checkin.gdpr-button-1-simplex": "Hausordnung des Hotels",
  "checkin.gdpr-button-1-hostz": "Hausordnung des Hotels",
  "checkin.gdpr-button-1-hostz-swissstay": "Hausregeln",
  "checkin.gdpr-button-1-offgrid": "Allgemeinen Geschäftsbedingungen",

  "checkin.terms-and-conditions": "Allgemeine Geschäftsbedingungen",
  "checkin.hotel-regulations": "Hotelordnung",

  "checkin.terms-and-conditions-button-detail": "des Aufenthalts im Hotel",

  "checkin.click-edit-data-text1": " um die notwendigen Änderungen vorzunehmen. Nachdem du die Änderungen vorgenommen hast, drücke ",
  "checkin.click-edit-data-text2": " und dann ",
  "checkin.click-edit-data-text3": ". Vielen Dank für deine Mitarbeit!",
  "checkin.the_myde_selfie_message": "Bitte laden Sie ein <b>Selfie von sich hoch, auf dem Sie Ihren Ausweis</b> (Reisepass, Personalausweis oder Führerausweis) halten. So helfen Sie uns, Ihren Aufenthalt sicher und reibungslos zu gestalten.",
  "checkin.selfie.required": "Selfie ist erforderlich",
  "checkin.dniBack.required": "Bild der Rückseite erforderlich",
  "checkin.floor-selection": "Mobilitätseinschränkung?",
  "checkin.floor-selection-text": "Bitte wählen Sie den Stock aus, in dem Sie einchecken möchten.Bitte beachten Sie, dass wir keine Aufzüge haben.",
  "checkin.ground-floor": "Ja, ich benötige ein Apartment so wenig Stufen wie möglich",
  "checkin.first-floor": "Erste Etage",
  "checkin.indifferent": "Gleichgültig",
  "checkin.entry-time-not-know-yet": "Ich weiß es noch nicht",
  "checkin.child": "Kind",
  "checkin.child-s": "Kind(er)",
  "checkin.children": "Kinder",
  "checkin.no-children": "Keine Kinder",
  "checkin.babies": "Säuglinge",
  "checkin.years": "Jahre",
  "checkin.no.name.yet": "Name noch nicht angegeben",



  "checkin.dniFront.required": "Bild des Vorderseite erforderlich",
  "checkin.selfie.required": "Selfie ist erforderlich",
  "checkin.dniBack.required": "Bild der Rückseite erforderlich",
  "checkin.the_myde_selfie_message_title": "Wichtig!",
  "checkin.please-complete-your-checkin-title": "Ausstehender Check-in",
  "checkin.please-complete-your-checkin-text": "Bitte schließen Sie Ihren Check-in ab, indem Sie hier klicken.",

  "general.notifications": "Benachrichtungen",
  "general.notifications_description": "Hier findest du einen Überblick über deine persönlichen Benachrichtigungseinstellungen. Passe sie nach deinen Wünschen an, um immer die Informationen zu erhalten, die für dich wichtig sind.",

  "status.settings": "Benachrichtigungen",
  "status.settings_description": "Einstellungen verwalten",

  "status.wifi": "WiFi",
  "status.wifi_description": "WiFi-Zugang",
  "status.wifi_name": "Netzwerkname",
  "status.wifi_password": "Passwort",
  "status.wifi_no_password": "Keines (offenes Netzwerk)",
  "status.garbage": "Anweisungen zur Müllentsorgung",
  "status.parking_info": "Parkhinweise",
  "status.garbage_description": "Alles, was Sie wissen müssen",
  "status.extra-bed": "Anleitung für Zustellbett",
  "status.extra-bed_description": "Sehen Sie, wie Sie Ihr Zustellbett aufbauen.",
  "status.parking_info_description": "Alles, was Sie wissen müssen",
  "status.access_code": "Zugangscodes",
  "status.room_access_code": "Zugangscodes für Räume",
  "status.room_keys": "Zimmerschlüssel",
  "status.room_keys_description": "Sie können sie an den Schlüsselkasten in der Lobby abholen",
  "status.room_keys_description_becozy": "Holen Sie sie im Schlüsselkasten an Ihrer Zimmertür ab",
  "status.room_keycard": "Zimmer-Schlüsselkarte",
  "status.room_keycard_description": "Einfach an der Rezeption abholen",
  "status.apartment_keys": "Wohnungsschlüssel",
  "status.apartment_keys_description": "Holen Sie einfach Ihre Schlüssel aus dem Schlüsselkasten am Haupteingang",

  "status.access_code_one": "Zugangscode",
  "status.access_code.pin_code": "PIN-Code",
  "status.access_code_hostz": "Wohnung Zugangscodes",
  "status.access_information": "Zugangsinformationen",
  "status.apartment_access": "Zugang zur Wohnung",
  "status.access_information_extramsg_steiners": "Die Rezeption ist jeden Tag zwischen {0} und {1} geöffnet und befindet sich nach der Haupteingangstür auf der linken Seite",
  "status.access_information_description": "Alles, was Sie benötigen, um auf das Grundstück zuzugreifen",
  "status.access_code_description": "Zugriffsinformationen",
  "status.access_code.main_entrance": "Eingangstür",
  "status.access_code.main_door": "Zugangscode für den",
  "status.access_code.room_door": "Haupteingang Raumschlosscode",
  "status.access_code.ladder": "Treppencode",

  "status.access_information.access_to_room_themyde": "Zugang zu Ihrem Apartment",
  "status.access_code.ladder_themyde": "Haupttür / Treppencode",

  "status.access_code.hostz-becozy": "At the main entrance of the hotel, you will find a keypad on the left- hand side.Enter the access code for the hotel to gain entry.<br><br> Once inside, the key to your room will be in a lockbox directly attached to your room door.To open the lockbox, enter the code and pull the small lever on the left to open the box and collect your room key.",

  "status.access_information.access_to_hotel": "Zugang zum Hotel",
  "status.access_information.accesses_swissstay": "Zugänge",
  "status.access_information.access_to_room": "Zugang zu Ihrem Zimmer",

  "status.access_code.main_entrance_themyde": "TÜREN & EINGÄNGE",
  "status.access_information.access_to_room_cover": "Während Ihres Aufenthalts finden Sie hier die Anweisungen zum Erhalt der Zugangsschlüssel",
  "status.access_information.access_to_room_cover_arosa": "Verfügbar um 16:00 Uhr",
  "status.access_information.access_to_room_cover_sigma": "Verfügbar um 16:00 Uhr",

  "status.access_information.access_to_room_description_cozy": "Hole deine Schlüsselkarte aus den grünen Schlüsselboxen (Keynest) in der Lobby.",
  "status.access_information.main_entrance_description_steiners": "Die Tür ist tagsüber geöffnet. <br>Wenn sie geschlossen ist, verwenden Sie bitte den untenstehenden Code, um die SCHLÜSSELBOX NR.1 zu öffnen und die darin befindliche digitale Karte zum Öffnen der Haupttür zu verwenden.",
  "status.access_information.access_to_room_description_steiners": "Holen Sie Ihre Schlüsselkarte aus den grünen Schlüsselboxen im 2. Stock.",


  "status.access_instructions": "Zugangsanweisungen",
  "status.access_instructions_description": "Ihr Zugangsverfahren",
  "status.access_code.key_collection_code": "Schlüsselabholcode - Collection code",
  "status.access_code.key_dropoff_code": "Schlüsselrückgabecode - Drop off code",
  "status.access_code.key_dropoff": "Schlüsselabgabe",
  "status.access_code.key_dropoff_instructions": "Werfen Sie den Schlüssel in die schwarze Box neben der grünen Box, wo Sie Ihre Schlüssel abgeholt haben.",

  "status.access_code.key_card_collection_code": "Code zur Abholung der Schlüsselkarte - Collection code",
  "status.access_code.key_card_dropoff_code": "Code zur Rückgabe der Schlüsselkarte - Drop off code",

  "status.access_information.before_checkin": "Zugangsdaten sind am Tag des Check-ins verfügbar.",
  "status.access_information.before_checkin_with_hours": "Der Code für den Hoteleingang ist ab {0} am Check-in-Tag sichtbar. Die Details zu Ihrem Zimmer (Nummer und Schlüsselkasten-Code) sind ab {1} am selben Tag verfügbar.",
  "status.access_information.before_checkin_with_hours_themyde": "Du kannst deine Zugangsdaten ab {0} sehen (Check-in-Zeit)",
  "status.access_information.before_checkin_with_hours_cozy": "Zugangsinformationen sind am Tag des Check-ins um {0} sichtbar, nur wenn das Check-in-Formular ausgefüllt und die Zahlung (einschließlich der Kaution von {1}) abgeschlossen wurde.",
  "status.access_information.before_checkin_with_hours_steiners": "Die Zugangsinformationen werden am Check-in-Tag ab {0} sichtbar, nur wenn das Check-in-Formular ausgefüllt. Wenn Sie Ihre Buchung gerade erst bezahlt haben und die Check-in-Zeit bereits überschritten ist, warten Sie bitte 3–5 Minuten, bis die Transaktion verarbeitet wurde. Sobald die Zahlung genehmigt ist, werden die Informationen automatisch sichtbar.",
  "status.access_information.before_checkin_with_hours_no_sd": "Zugangsinformationen sind am Tag des Check-ins um {0} sichtbar, nur wenn das Check-in-Formular ausgefüllt und die Zahlung.",
  "status.access_information.before_checkin_main": "Sie sind ab {0} morgens herzlich eingeladen, das Hotel zu betreten und die Einrichtungen zu nutzen. Sie können auch Ihr Gepäck in der Aufbewahrung abstellen, während Sie darauf warten, dass Ihr Zimmer ab {1} bereit ist. Die Zimmerdetails werden um {1} mitgeteilt.",
  "status.access_information.before_checkin_room": "Der Code für den Hoteleingang ist ab {0} am Check-in-Tag sichtbar. Die Details zu Ihrem Zimmer (Nummer und Schlüsselkasten-Code) sind ab {1} am selben Tag verfügbar.",
  "status.access_information.after_checkin": "Ihr Aufenthalt ist beendet und die Zugangsdaten sind nicht mehr verfügbar. Vielen Dank für Ihren Besuch in unserem Hotel — wir hoffen, Sie bald wieder begrüßen zu dürfen!",
  "status.access_information.main_entrance": "Haupteingang",
  "status.access_information.main_entrance_code": "Haupteingangscode",
  "status.access_information.main_entrance_code_sigma": "Haupteingangscode & Rückseiteingangscode",
  "status.access_information.main_entrance_code_swissstay": "Hauptzugang",
  "status.access_information.main_entrance_code_and_skiroom_code": "Haupteingangscode & Skischlüsselcode",
  "status.access_information.room_keybox_code": "Schlüsselkasten-Code (befindet sich neben der Tür Ihres Zimmers)",
  "status.access_information.room_keybox_code_arosa": "Schlüsselkasten-Code (Der Schlüsselkasten befindet sich AN IHRER ZIMMERTÜR)",
  "status.access_information.please_use_main_key": "Bitte benutzen Sie den HAUPTSCHLÜSSEL",
  "status.access_information.link_modal_video": "Sieh dir dieses kurze Video an, um den Check-in zu verstehen",
  "status.access_information.link_modal_video_themyde": "Sieh dir dieses kurze Video an, um den Check-in zu verstehen",
  "status.access_information.title_modal_video": "Wie man es benutzt",
  "status.access_information.room_lock_box_code": "Code des Schlüsselkastens",
  "status.access_information.room_lock_box_location": "Standort des Schlüsselkastens",

  "cups.title": "Extras",
  "cups.remove_button": "Entfernen",
  "cups.add_button": "Hinzufügen",
  "cups.subject_to_availability": "Je nach Verfügbarkeit",
  "cups.subject_to_availability_text": "Dieser Artikel unterliegt der Verfügbarkeit. Während dieses Vorgangs fallen keine Kosten an, und nach der Auswahl wird sich ein Hotelmitarbeiter mit Ihnen in Verbindung setzen, um weitere Einzelheiten zu diesem Artikel zu besprechen.",
  "cups.preferedList_text": "Basierend auf Ihren Interessen haben wir diese Erlebnisse für Sie",
  "cups.otherList_text": "Vielleicht interessieren Sie sich auch für diese Erlebnisse",
  "cups.tags.best-selling": "Bestseller",
  "cups.tags.most-popular": "Am beliebtesten",
  "cups.tags.best-price": "Bester Preis",
  "cups.priceIsPerNight": "pro Nacht",
  "cups.confirm": "Diesen Kauf bestätigen?",
  "cups.booked": "Bezahlt",
  "cups.spots": "Platz",

  "date.january": "Januar",
  "date.february": "Februar",
  "date.march": "März",
  "date.april": "April",
  "date.may": "Mai",
  "date.june": "Juni",
  "date.july": "Juli",
  "date.august": "August",
  "date.september": "September",
  "date.october": "Oktober",
  "date.november": "November",
  "date.december": "Dezember",


  "checkout.loading-information":
    "Bitte warten Sie, während ich alle notwendigen Informationen sammle.",
  "checkout.errors-title": "Ihr Check-out kann nicht bearbeitet werden",
  "checkout.error-balance":
    "Ihr Guthaben beträgt {0}. Bitte begleichen Sie Ihr Konto, um fortfahren zu können.",
  "checkout.error-departure":
    "Ihr Check-out-Datum ist {0}. Möchten Sie Ihren Aufenthalt verkürzen?",
  "checkout.button": "Fahren Sie mit der Kasse fort",
  'checkout.error-departure-button': "Brauchen Sie Hilfe? Sprechen Sie mit uns!",

  'checkout.error-noShowBalance': "Brauchen Sie Hilfe oder haben Sie Fragen? Wir sind für Sie da! Klicken Sie einfach auf den Chat-Button unten, um Kontakt aufzunehmen. Möchten Sie Ihr Konto kündigen? Auch das können Sie hier ganz einfach erledigen. Denken Sie daran, Ihre Zufriedenheit steht bei uns an erster Stelle.",
  "checkout.success-title": "Ihr CheckOut war erfolgreich!",
  "checkout.debt": "Wir können den Checkout nicht durchführen. Ihr Aufenthalt hat einen ausstehenden Betrag von: ",
  "checkout.pay_now": "Jetzt zahlen",
  "checkout.ask_for_balance": "Leider können wir den Checkout im Moment nicht bearbeiten. Bitte chatten Sie mit uns für weitere Anweisungen.",
  "checkin.sign-and-confirm": "Unterschreiben und bestätigen",

  "maps.how_to_reach_us": "Wie erreichen Sie uns?",
  "maps.get_directions": "Wegbeschreibung abrufen",

  "room-categories.air-conditioning": "Klimaanlage",
  "room-categories.complimentary-dressing": "Kostenloses Ankleiden",
  "room-categories.work-area": "Arbeitsbereich",
  "room-categories.private-balcony": "Privater Balkon",
  "room-categories.cable": "Kabel",
  "room-categories.safe-box": "Safe",
  "room-categories.sommier-beds": "Sommier-Betten",
  "room-categories.room": "Zimmer",
  "room-categories.hydromassage": "Hydromassage",
  "room-categories.coffee-machine": "Kaffeemaschine",
  "room-categories.minibar": "Minibar",
  "room-categories.hairdryer": "Fön",
  "room-categories.selection-of-pillows": "Auswahl an Kissen",
  "room-categories.ironing-service": "Bügelservice",
  "room-categories.smart-tv": "Smart-TV",
  "room-categories.king-size-bed": "Kingsize-Bett",
  "room-categories.phone": "Telefon",
  "room-categories.tv-lcd": "TV-LCD",
  "room-categories.satellite-tv": "Satelliten-TV",
  "room-categories.street-view": "Straßenansicht",
  "room-categories.garden-view": "Gartenaussicht",
  "room-categories.sea-view": "Seeblick",
  "room-categories.wifi": "W-lan",
  "room-categories.kettle": "Wasserkocher",
  "room-categories.fridge": "Kuehlschrank",
  "room-categories.dishwasher": "Dishwasher",
  "room-categories.oven": "Ofen",
  "room-categories.freezer": "Fridner",
  "room-categories.water-heater": "Kuehlschrank",
  "room-categories.plates-glasses": "Pläne und Glas",
  "room-categories.cutlery-dishes": "Schäfer, Speisen und Tische",
  "room-categories.microwave": "Mikrowelle",
  "room-categories.kettle": "Kettler",
  "room-categories.nespresso-machine": "Nespresso- Maschine",

  "room-categories.toilette-with-shower-box": "Empfangs-Toilette mit Duschkabine",
  "room-categories.sofa-bed": "Schlafsofa",
  "room-categories.partial-sea-view": "Teilmeerblick",
  "room-categories.welcome-amenities": "Willkommensausstattung",
  "room-categories.shower": "Dusche",
  "room-categories.bathtub": "Badewanne",
  "room-categories.double-sink": "Doppelwaschbecken",
  "room-categories.connected-rooms": "Verbundene Zimmer",
  "room-categories.king-or-twin-beds": "Kingsize-Bett oder Einzelbetten",
  "room-categories.los-troncos-view": "Blick auf das Los Troncos Viertel",
  "room-categories.daily-courtesy-water": "Tägliches Gratis-Wasser",
  "room-categories.daily-courtesy-capsule-dilmah": "Tägliche Gratis-Dilmah-Kapsel oder Aufguss",
  "room-categories.stay-courtesy-capsule-dilmah": "Gratis-Dilmah-Kapsel oder Aufguss für den Aufenthalt",

  "meeting_rooms.dvd-player": "DVD Spieler",
  "meeting_rooms.high-speed-wi-fi": "Highspeed-WLAN",
  "meeting_rooms.independent-access": "Unabhängiger Zugang",
  "meeting_rooms.lunch-service": "Mittagsservice",
  "meeting_rooms.meeting-room": "Konferenzraum",
  "meeting_rooms.megaphone": "Megaphon",
  "meeting_rooms.microphone": "Mikrofon",
  "meeting_rooms.smart-tv": "Smart-TV",
  "meeting_rooms.video-projection": "Videoprojektion",
  "meeting_rooms.capacity": "Kapazität:",
  "meeting_rooms.people": "Personen.",
  "welcome.title": "Willkommen in unserem Hotel!",
  "welcome.subtitle": "Wir wünschen Ihnen einen tollen Aufenthalt!",
  "welcome.text":
    "<b>Mein Name ist ViCo und ich werde Ihr virtueller Concierge sein!</b> Ich bin 24 Uhrzeitn am Tag erreichbar und Sie können mich alles fragen! Geben Sie dazu den Bereich „Anfrage“ ein, in dem Sie Zimmerservice, Zimmerreinigung, Zimmerzubehör usw. bestellen können",
  "welcome.text-hostz-becozy": "Willkommen in unserem Becozy Basel, hier finden Sie alles, was Sie benötigen, um das Beste aus Ihrem Aufenthalt zu machen.<br><br>Über dieses Portal können Sie Ihr Erlebnis mit unseren verfügbaren Services verbessern, unsere Unterkunft erkunden, Aktivitäten in der Umgebung entdecken und vieles mehr.",
  "welcome.text-hostz-san-carlo": "Willkommen in unserem Hotel San Carlo in Lugano, hier finden Sie alles, was Sie benötigen, um das Beste aus Ihrem Aufenthalt zu machen.<br><br>Über dieses Portal können Sie Ihr Erlebnis mit unseren verfügbaren Services verbessern, unsere Unterkunft erkunden, Aktivitäten in der Umgebung entdecken und vieles mehr.",
  "welcome.text-hostz-blacksummit": "Willkommen im Black Summit Resort in Laax! In diesem Portal finden Sie alles, was Sie benötigen, um das Beste aus Ihrem Aufenthalt zu machen.<br><br>Über dieses Portal können Sie Ihr Erlebnis mit unseren verfügbaren Services verbessern, unsere Unterkunft erkunden, Aktivitäten in der Umgebung entdecken und vieles mehr.",
  "welcome.text-hostz-betahouse": "Willkommen! Sie sind jetzt eingecheckt.",
  "welcome.text-hostz-themyde": "<br/><br/><b>Willkommen! Sie sind jetzt eingecheckt. </b>Alle Ihre Zugangsdaten finden Sie im Abschnitt Zugangsinformationen auf Ihrem Dashboard.<br/><br/></br/>",
  "welcome.text-hostz-arosa": "<br/><br/><b>Willkommen! Sie sind jetzt eingecheckt. </b>Alle Ihre Zugangsdaten finden Sie im Abschnitt Zugangsinformationen auf Ihrem Dashboard.<br/><br/></br/>",
  "welcome.text-hostz-swissstay": "Willkommen! Sie sind jetzt eingecheckt. Alle Ihre Zugangsdaten finden Sie im Abschnitt Zugangsinformationen auf Ihrem Dashboard.",
  "welcome.text-hostz-steiners": "Willkommen! Sie sind jetzt eingecheckt. Alle Ihre Zugangsdaten finden Sie im Abschnitt Zugangsinformationen auf Ihrem Dashboard.",

  "welcome.subtitle-offgrid": "Willkommen in deinem Cabin Guide :)",
  "welcome.text-offgrid": "Hier findest du alles Wichtige rund um deinen Aufenthalt – vom <b>Online Check-in</b> über <b>Anreiseinfos</b> bis hin zu hilfreichen Tipps für deine Zeit in der Cabin.<br><br>Wenn du Fragen hast, kannst du dich jederzeit bei uns melden – wir helfen dir gerne weiter!<br>Für dringende Anliegen schreib uns einfach direkt über <b>WhatsApp an +49 30 54806375</b>.",
  "welcome.footer-offgrid": "👉 Für einen einfachen Zugriff kannst du den Cabin Guide auf deinem <b>Startbildschirm speichern</b>. Tippe dafür einfach auf <b>\"Akzeptieren\"</b> und ziehe das Icon an die gewünschte Stelle. Es nimmt keinen Platz ein und du kannst es jederzeit wieder entfernen, sobald du abgereist bist.<br><br><b>Wir wünschen dir einen wunderbaren Aufenthalt!</b> 🌿 ",
  "welcome.room-offgrid": "Cabin",
  "welcome.text-simplex": "Willkommen! Sie sind nun angemeldet. Alle Ihre Zugangsinformationen finden Sie nun im Bereich „Zugangsinformationen“ Ihres Dashboards.",
  "welcome.footer-hostz": "Um den Zugang zu erleichtern, empfehlen wir Ihnen, Benachrichtigungen zu aktivieren und eine Verknüpfung auf Ihrem Startbildschirm zu erstellen. So bleiben Sie über wichtige Informationen zu Ihrem Aufenthalt auf dem Laufenden und können problemlos Anfragen stellen, um Ihren Aufenthalt noch angenehmer zu gestalten.",
  "welcome.footer-hostz-betahouse": "Alle Ihre Zugangsdaten finden Sie im Abschnitt Zugangsinformationen auf Ihrem Dashboard.",

  "welcome.room": "Ihr Zimmernummer ist:",
  "welcome.room_bs": "Ihre Wohnung ist:",
  "welcome.footer":
    "Für einen einfachen Zugriff erlauben Sie mir bitte, eine Verknüpfung auf Ihrem Startbildschirm zu erstellen. Klicken Sie einfach auf „Akzeptieren“ und ziehen Sie es an die gewünschte Stelle. Es nimmt keinen Platz ein und Sie können es entfernen, sobald Sie das Hotel verlassen.<br /><br /><b>Wir helfen Ihnen gerne weiter!</b>",
  "welcome.start": "Start",
  "services.type.general": "Anfragen",
  "services.type.room_service": "Zimmerservice",
  "services.type.room_supplies": "Raumbedarf",
  "services.type.laundry": "Wäscherei",
  "services.type.porter": "Porter",
  "services.type.tray_collection": "Tablettsammlung",
  "services.type.pressing": "Drücken",
  "services.type.housekeeping": "Hauswirtschaft",
  "services.type.wakeup_call": "Weckruf",
  "services.type.car_valet": "Parkservice",
  "services.type.concierge": "Portier",
  "services.type.lost_objects": "Verlorene Gegenstände",
  "services.type.breakage_report": "Bruchbericht",
  "services.type.services_booking": "Buchung von Dienstleistungen",
  "services.type.review_tracking": "Lösungsticket für Ihr Feedback",
  "services.type.up_selling": "Extras",
  "services.type.items_sales": "Produkte",
  "services.type.gift_store": "Geschenkgeschäft",
  "services.housekeeping.horary":
    "Denken Sie daran, dass die Zimmerreinigung von 7.00 bis 14.00 Uhr erfolgen muss. Andernfalls wird Ihr Zimmer nicht gereinigt.",
  "services.housekeeping.do-not-change-towels":
    "Wechseln Sie heute keine Handtücher",
  "services.housekeeping.button-title": "Anfrage senden",
  "services.donotdisturb.button-title-activate":
    "Schalten Sie den Modus <b>NICHT STÖREN</b> ein",
  "services.donotdisturb.button-title-disable":
    "Schalten Sie den Modus <b>NICHT STÖREN</b> aus",
  "services.donotdisturb.extra-info":
    "Solange der Modus <b>NICHT STÖREN</b> aktiv ist, ist eine Bereinigung oder Beantwortung Ihrer Anfragen nicht möglich.",
  "services.do-not-change-towels": "Wechseln Sie die Handtücher nicht",
  "services.sent-text":
    "<b>Anfrage gesendet!</b> Sobald die Anfrage bearbeitet wurde, werden Sie benachrichtigt. Sie können sie auch über den Bildschirm <b>Dashboard</b> verfolgen.",
  "services.go-to-requests": "Gehen Sie zum Dashboard",
  "services.go-to-home": "Gehen Sie zur Startseite",
  "services.status.pending": "Ausstehend",
  "services.status.observed": "Rezension",
  "services.status.in_progress": "Im Gange",
  "services.status.in_transit": "Auf dem Weg",
  "services.status.accepted": "Akzeptiert",
  "services.status.done": "Geliefert",
  "services.status.canceled": "Abgesagt",
  "services.status.on_hold": "Ausstehend",
  "services.status.seated": "Eingegangen",
  "services.status.confirmed": "Bestätigt",
  "services.active-request": "Es gibt {0} aktive Anfrage!",
  "services.active-requests": "Es gibt {0} aktive Anfragen!",
  "select...": "Wählen...",
  "services.confirm-request": "Ist Ihre Bestellung abgeschlossen?",

  "smartlocks.swipe-to-open": "ZUM ÖFFNEN WISCHEN",
  "smartlocks.pin-code-arosa-explanation": "Nachdem Sie den PIN CODE eingegeben haben, müssen Sie die # oder ↵ (Enter) Tasten drücken, um zu bestätigen.",

  "status.messages": "Neue Nachrichten!",
  "status.no_messages": "Wir haben noch nicht auf Ihre Anfrage zu diesem Thema geantwortet. Wir werden uns in Kürze bei Ihnen melden.",
  "status.more": "Mehr über deinen Aufenthalt",
  "status.faqs": "Häufig gestellte Fragen",
  "status.faqs_description": "Alle Informationen an einem Ort",
  "status.contact": "Kontaktiere uns",
  "status.contact_whatsapp": "Schreibe uns ein Whatsapp",
  "status.contact_description": "Wir helfen dir gerne weiter!",
  "status.settings.btnDescription_facilities_arosa": "Tolle Angebote unserer Partner",
  "status.checkin_alert": "Neuigkeiten zu Ihrem Check-in",
  "status.checkin_alert_offgrid": "Neuigkeiten zu deinem Check-in",
  "status.checkin_edit": "Check-in Informationen aktualisieren",
  "status.checkout_description": "Check-out durchführen",
  "status.checkin.chat": "Check-in Nachrichten",
  "status.stay_description": "Info zum Aufenthalt",
  "status.stay.info": "Aufenthaltsinfo",
  "status.checkin.chat-desc": "Hast du Fragen zu deinem Check-in?",

  "status.location": "Standort",
  "status.location_description": "Wegbeschreibung zur Unterkunft erhalten.",
  "status.location_description_swissstay": "Wegbeschreibung zum Apartment abrufen.",
  "status.parking": "Parkplatz",
  "status.parking_description": "Zugang & Regeln",

  "bookable.limit": "Reservieren bis",
  "account.add-device": "Gerät hinzufügen",
  "account.stay": "Dein Aufenthalt",
  "account.room": "Zimmer",
  "account.more-info": "Mehr Info",
  "account.guest": "Gast",
  "account.charges": "Leistungen",
  "account.payments": "Zahlungen",
  "account.accommodation": "Unterkunft",
  "account.accommodation_description": "Übernachtung",
  "account.citytax": "Kurbeitrag",
  "account.foodandbeverages": "Lebensmittel und Getränke",
  "account.foodandbeverages_description": "Verbrauch von Bar, Restaurant usw.",
  "account.other": "Zusatzgebühren",
  "account.other_description": "Sonstige Kosten des Aufenthalts",
  "account.download": "Herunterladen",
  "account.invoices": "Rechnungen",
  "account.balance": "Gleichgewicht",
  "account.chat": "Bei Fragen zur Rechnung wenden Sie sich gerne an uns.",

  "Please check the rooms for room amenities as they may vary":
    "Bitte prüfen Sie die Zimmer für Zimmereigenschaften, da sie variieren kÃ¶nnen.",


  "review.rate": "Bewertung:",
  "review.rate_us": "Bewerten Sie uns!",
  "review.thanks": "Vielen Dank, Ihre Bewertung wurde gespeichert.",
  "review.rate-placeholder": "Bitte hinterlassen Sie hier Ihr Feedback...",
  "review.extra_rate": "Zusätzliches Feedback",
  "review.extra_rate_text": "Diese Bewertungen helfen uns, unseren Service zu verbessern",
  "review.sending_response": "Antwort wird gesendet…",
  "review.already-rated": "Vielen Dank für Ihre Bewertung, Ihre Meinung ist sehr wertvoll.",
  "review.already-rated-button": "Ich möchte meine Bewertung ändern.",
  "review.average": "Durchschnitt",
  "review.general": "Allgemein",
  "review.contact": "Bitte teilen Sie uns Ihre Kontaktdaten mit, damit wir auf Ihre Bewertung zurückkommen können.",
  "review.screen_title": "Bewertung",
  "review.flow_type_rating": "Sterne",
  "review.flow_type_single_choice": "Einfachauswahl",
  "review.flow_type_opinion_scale": "Meinungsskala",
  "review.flow_type_ranking": "Ranking",
  "review.flow_type_landing": "Landing",


  "request.detail-title": "Anfragedetails",
  "request.delivery-point": "Lieferpunkt",
  "request.continue_customize": "Weiter & Anpassen",
  "request.your-request": "Ihre Anfrage",
  "request.product": "Produkt",
  "request.products": "Produkte",
  "request.creating-order": "Bestellung wird erstellt",
  "request.creating-order-title": "Wir erstellen Ihre Bestellung",
  "request.creating-order-description": "Wir senden Ihre Bestellung an das Hotel. Das dauert nur wenige Sekunden.",
  "request.order-created": "Bestellung erstellt",
  "request.order-created-title": "Bestellung erfolgreich erstellt",
  "request.order-created-description": "Ihre Bestellung wurde registriert. Gleich bringen wir Sie zur Detailansicht, damit Sie sie verfolgen konnen.",
  "request.redirecting-to-order": "Weiterleitung zur Detailansicht in",
  "request.view-order-now": "Bestellung jetzt ansehen",
  "request.status-pending": "Ausstehend",
  "request.confirm-cancel":
    "Dadurch wird Ihre Anfrage storniert. Möchten Sie fortfahren?",
  "request.only-one-for-type":
    "Sie können nur eine offene Anfrage dieser Art haben!",
  "request.lost_objects.observation":
    "Beschreiben Sie hier detailliert, welche Gegenstände Sie verloren haben und wann und wo Sie diese möglicherweise verloren haben",
  "request.generic.observation": "Hinterlassen Sie uns hier einen Kommentar",
  "request.general.observation": "Wenn du Fragen hast oder Unterstützung benötigst, lass es uns einfach wissen - wir sind für dich da!",
  "request.car_valet.observation": "Teilen Sie uns mit, wie wir Ihnen mit Ihrem Fahrzeug helfen können...",
  "request.tray_collection.observation": "Irgendwelche besonderen Anweisungen für Ihre Abholung?",
  "request.breakage_report.observation": "Bitte teilen Sie uns mit, was kaputt ist oder nicht ordnungsgemäß funktioniert",
  "request.housekeeping.observation": "Bitte teilen Sie uns mit, wenn Sie hier besondere Anforderungen haben",
  "public.personal-information": "Persönliche Informationen",
  "public.input.number": "Nummer",
  "services.type.beach_service": "Beach service",
  "service.type.request": "Anfrage",
  "public.request.payment-status.pay-again": "Zahlung wiederholen",
  "public.request.payment-status.not-captured": "Zahlung konnte nicht eingezogen werden. Bitte versuchen Sie es erneut, um Ihre Anfrage abzuschließen.",
  "public.dashboard.cgbeach.public_cart": "Bestellung aufgeben",



  "request.option": "Option",
  "request.observations": "Bemerkungen",
  "request.observations-placeholder": "Teilen Sie uns Fragen oder Wünsche gerne mit",
  "request.create.comment": "Hinterlassen Sie einen Kommentar auf Ihre Anfrage",
  "request.reserved-days": "Reservierte Tage",

  "notifications.enable": "Benachrichtigungen aktivieren",
  "notifications.not_now": "Nicht jetzt",
  "notifications.accept":
    "<b>Wichtig:</b> Bitte aktivieren Sie Benachrichtigungen, damit Sie Statusaktualisierungen zu Ihren Anfragen in Echtzeit erhalten können!",
  "notifications.accepted":
    '<b class="text-success">Benachrichtigungen aktiviert!</b> Sie erhalten während Ihres Aufenthalts Echtzeit-Updates zu Ihrem Check-in-Prozess und Ihren Anfragen!',
  "notifications.blocked":
    '<b class="text-danger">Benachrichtigungen blockiert!</b> Bitte erlauben Sie Benachrichtigungen, damit wir Ihnen wichtige Statusaktualisierungen zu Ihren Anfragen senden können! Klicken Sie auf das Schlosssymbol in der Adressleiste Ihres Browsers. Klicken Sie, um den Benachrichtigungsschalter einzuschalten. Danke!',
  "notifications.confirm-continue":
    "<b>Bist du dir sicher, dass du weitermachen willst?</b> Benachrichtigungen verbessern Ihr Gesamterlebnis während Ihres Aufenthalts bei uns!",
  "notifications.empty-title": "Sie haben keine Benachrichtigungen!",
  "notifications.empty-text":
    "Wenn Sie eines erhalten, wird es hier angezeigt.",
  "notificacions.title": "Benachrichtigungen",
  "notifications.link.make-the-review": "Bewertung abgeben",

  "stay.add-device-use-qr":
    "Verwenden Sie den QR von einem anderen Gerät, um ihn dem Aufenthalt hinzuzufügen.",

  "yup.required": "Das Feld ist Pflichtfeld",
  "yup.only-letters": "Nur Buchstaben sind zulässig",
  "yup.only-numbers": "Nur Zahlen sind zulässig",
  "yup.only-numbers-and-letters": "Nur Zahlen und Buchstaben",
  "yup.minimal-6-digits": "Es muss mindestens 6 Ziffern enthalten",
  "yup.minimal-7-digits": "Es muss mindestens 7 Ziffern enthalten",
  "yup.minimal-2-letters": "Es muss mindestens 2 Buchstaben enthalten",
  "yup.maximal-50-letters": "Es darf nicht mehr als 50 Buchstaben enthalten",
  "yup.maximal-12-digits": "Es darf nicht mehr als 12 Ziffern enthalten",
  "yup.maximal-25-digits": "Es darf nicht mehr als 25 Ziffern enthalten",
  "yup.wrong-date": "Falsches Datum",
  "yup.please-review": "Bitte überprüfen Sie diesen Wert",
  "yup.email-invalid-format": "Falsches E-Mail-Format",

  "toast.do-not-disturb-mode-active-title": '"Bitte nicht stören" modus aktiv',
  "toast.do-not-disturb-mode-active-text":
    "Um neue Anfragen zu stellen, müssen Sie zunächst den „Bitte nicht stören“-Modus deaktivieren.",
  "toast.do-not-disturb-mode-active-link": "Abschalten",

  "payments.summary-of-charges": "Zusammenfassung der Gebühren",
  "payments.guarantee-deposit-paid": "Ihre Reservierung hat bereits eine aktive Sicherheitskaution.",
  "payments.balance-paid": "Ihre Reservierung hat keinen ausstehenden Betrag.",
  "payments.total-to-pay": "Total zu bezahlen",
  "payments.pay": "Bezahlen",
  "payments.retry-pay": "Zahlung wiederholen",
  "payments.items-pay-with-deposit": "Die zu zahlenden Gebühren sind nachstehend aufgeführt:",
  "payments.guarantee-deposit": "Sicherheitskaution",
  "payments.guarantee-deposit-desc": "Dieser Betrag wird einbehalten, jedoch nicht von Ihrer Kreditkarte abgebucht.",
  "payments.select-items-pay": "Wählen Sie die Artikel, die Sie bezahlen möchten",
  "payments.payment-ok": "Ihre Zahlung wurde erfolgreich durchgeführt",
  "payments.payment-error": "Beim Versuch, die Zahlung vorzunehmen, ist ein Fehler aufgetreten",
  "payments.payment-not-authorised": "Zahlung nicht autorisiert",
  "payments.pending-confirmation": "Wir bestätigen Ihre Zahlung mit der Bank. Bitte schließen Sie diesen Bildschirm nicht.",
  "payments.pending-timeout": "Die Zahlungsbestätigung dauert länger als üblich. Bitte versuchen Sie es erneut oder kontaktieren Sie die Rezeption.",
  "payments.payment-unavailable-continue": "Zahlung derzeit nicht verfügbar. Sie können mit dem Web-Check-in fortfahren und später bezahlen.",
  "payments.loading-component": "Zahlungskomponente wird geladen...",
  "payments.later": "Ich zahle später",
  "payments.confirm-pay-later": "Sie bestätigen die Bestellung und zahlen später. Verwenden Sie die Schaltfläche Kaufen unten.",
  "payments.back-to-pay-later": "später bezahlen wählen",
  "payments.later-sancarlo": "Barzahlung an der Rezeption. Bitte beachten Sie, dass unsere Rezeption von 9:00 bis 18:00 Uhr geöffnet ist. Wenn Sie nach 18:00 Uhr anreisen, steht diese Option nicht zur Verfügung.",
  "payments.msg_guarantee": "Im Black Summit Laax verlangen wir eine Kaution, um allen unseren Gästen einen sicheren und angenehmen Aufenthalt zu gewährleisten. Diese Kaution dient als Vorsichtsmaßnahme, um mögliche Schäden an der Immobilie, den Möbeln oder den Annehmlichkeiten sowie Nebenkosten wie zusätzliche Reinigung oder spätes Auschecken abzudecken. Die Kaution wird 7 Tage nach dem Check-out freigegeben, sobald die Immobilie inspiziert wurde und keine Probleme festgestellt wurden. Die Rückerstattung erfolgt über Ihre ursprüngliche Zahlungsmethode.",
  "payments.msg_guarantee_72hs": "Bitte beachten Sie, dass 72 Stunden vor Ihrer Ankunft eine Kaution von {0} CHF zwingend erhoben werden muss. Sie erhalten zur Erinnerung eine E-Mail-Benachrichtigung.",
  "payments.older": "Frühere Zahlung",

  "facilities.Carta_Belleza": "Beauty-Services",
  "spa.Carta_Tratamientos": "Massageangebote",
  "facilities.Carta_SPA": "Speisekarte",
  "home.chat-24-7": "Chat 24/7",
  "home.book-a-room": "Ein Zimmer buchen",
  "home.book-an-apartment": "Ein Apartment buchen",

  "door.main": "Haupttür",
  "door.back": "Hintertür",
  "room.address": "Adresse",
  "room.number": "Zimmernummer",
  "room.floor": "Stockwerk des Zimmers",
  "apartment.address": "Adresse der Wohnung",
  "apartment.number": "Wohnung",
  "apartment.floor": "Stockwerk",

  "public.bookable.init": "Bitte wählen Sie die Anzahl der Personen und das Datum, um die Verfügbarkeit zu prüfen",
  "public.bookable.sent-text": "<b>Anfrage gesendet!</b> <br/>Sie werden benachrichtigt, sobald Ihre Buchung bearbeitet wurde.",
  "public.bookable.fill-data": "Bitte füllen Sie die folgenden Angaben aus, um Ihre Tagesreservierung abzuschließen:",
  "public.edit-hour": "Uhrzeit bearbeiten",
  "public.input.name-and-surname": "Name und Nachname",
  "public.input.phone": "Telefon",
  "public.input.email": "Email",
  "public.input.observations": "Bemerkungen",
  "public.bookable.gala-experience": "Have you attended a Hotel Gala before?",
  "public.bookable.gala-experience.required": "Please select an option",
  "public.input.location": "Standort",
  "public.input.location.arena": "Arena-Sommerbrille",
  "public.input.location.piscina": "Pool-Sommerbrille",
  "public.input.location.carpa": "Zelt",
  "public.input.tent": "Zeltnummer",
  "public.bookable.list-empty": "Keine verfügbaren Dienste zur Buchung.",
  "general.processing-request": "Anfrage wird verarbeitet...",
  "public.dashboard.home": "Startseite",
  "public.dashboard.services": "Dienstleistungen",
  "public.dashboard.my-profile": "Mein Profil",
  "public.reservation.status.accepted": "Anfrage akzeptiert",
  "public.reservation.status.canceled": "Abgesagt",
  "public.reservation.status.pending": "Benötigt Bestätigung",
  "public.reservation.status.confirmed": "Bestätigt",
  "public.request.confirmed": "Anfrage bestätigt am",
  "public.request.status.canceled-msg": "Die Anfrage wurde storniert.",
  "complete-to-web-checkin": "Web Check-in",

  "services.make-your-reservation": "Machen Sie Ihre Reservierung",
  "services.make-your-reservation-button": "Buchen Sie unsere Dienstleistungen",

  "public.reservation.not-found": "Reservierungsdetails nicht gefunden",
  "public.reservation.welcome": "Hallo {0}, hier sind Ihre Reservierungsdetails:",
  "public.reservation.date-and-hour": "Datum und Uhrzeit",
  "public.reservation.people": "Personen",
  "public.reservation.adults": "Erwachsene",
  "public.reservation.children": "Kinder",
  "public.reservation.state": "Status",
  "public.reservation.observations": "Bemerkungen",
  "public.request.cancel-assistance": "Teilnahme stornieren",
  "public.request.cancel-request": "Stornieren",
  "public.reservation.status.remember-status": "Akzeptiert",
  "public.dashboard.logout": "Abmelden",
  "public.dashboard.welcome": "Willkommen, {0}!",
  "public.dashboard.no-reservations": "Sie haben keine aktiven Reservierungen",
  "public.reservation.adult": "Erwachsene",
  "public.reservation.child": "Kind",
  "public.reservation.view-reservations": "Alle meine Reservierungen anzeigen",
  "public.reservation.confirm": "Bestätigen",
  "public.reservation.confirm_msg": "Sie können Ihre Reservierung bis zu 72 Stunden vor Beginn bestätigen.",
  "public.reservation.status.validating": "Anfrage verarbeiten",
  "public.request.status.validating-msg": "Ihre Anfrage wird verarbeitet, wir werden Sie benachrichtigen, wenn sie bereit ist.",
  "public.reservation.confirmated-at": "Reservierung bestätigt am",
  "public.request.forbidden.title": "Diese Anfrage kann nicht angezeigt werden",
  "public.request.forbidden.description": "Diese Anfrage entspricht nicht dem aktuellen Benutzer {0}. Wenn Sie diese Aktion fortsetzen möchten, wird Ihre aktuelle Sitzung geschlossen und Sie werden zur neuen Sitzung weitergeleitet.",
  "public.request.forbidden.button": "Zurück zum Dashboard",
  "public.reservation.status.accepted": "Akzeptiert",
  "public.reservation.status.confirmed": "Bestätigt",
  "public.dashboard.requests": "Anforderungen",
  "public.dashboard.not-found": "Benutzerprofil nicht gefunden",
  "public.dashboard.my-data": "Meine Daten",
  "public.dashboard.name": "Vollständiger Name",
  "public.dashboard.email": "E-Mail",
  "public.dashboard.phone": "Telefon",
  "public.dashboard.my-reservations": "Meine Reservierungen",
  "public.dashboard.my-requests": "Meine Anforderungen",
  "public.request.not-found": "Anforderungsdetails nicht gefunden",
  "public.request.welcome": "Hallo {0}, hier sind deine Anforderungsdetails:",
  "public.request.date-and-hour": "Datum und Uhrzeit",
  "public.request.people": "Personen",
  "public.request.passengers": "Passagiere",
  "public.request.title": "Anfragedetails",
  "public.request.state": "Status",
  "public.request.observations": "Bemerkungen",
  "public.request.additional-observations": "Zusätzliche Bemerkungen",
  "public.request.view-requests": "Alle meine Anforderungen anzeigen",
  "public.request.confirm-assistance": "Teilnahme bestätigen",
  "public.dashboard.go-to-my-reservations": "Zurück zu meinen Reservierungen",
  "menu.all": "Alle",
  "menu.search": "Im Menü suchen...",
  "menu.search_room_service": "Produkt suchen...",
  "menu.search_restaurant": "Im Restaurant suchen...",
  "menu.category": "Kategorie {0}",
  "menu.vegetarian": "Vegetarisch",
  "menu.gluten_free": "Glutenfrei",
  "menu.items_not_found": "Keine Artikel für diesen Service konfiguriert. Bitte wenden Sie sich an den Administrator.",
  "menu.fail_laod_items": "Fehler beim Laden der Serviceartikel. Bitte versuchen Sie es später erneut.",
  "menu.price_without_taxes": "Preis ohne nationale Steuern:",
  "no-hours.disabled.day": "Dieser Service steht heute nicht zur Verfügung.",
  "no-hours.disabled.general": "Außerhalb der Öffnungszeiten",
  "no-hours.disabled.slot": "Dieser Service ist derzeit nicht verfügbar. Bitte versuchen Sie es später erneut.",
  "general.invalid-dates": "Für Zeiträume von mehr als {0} Tagen sind keine Tarife verfügbar.",
  "general.selected-days": "Ausgewählte Tage",
  "general.selected-day": "Ausgewählter Tag",
  "general.day": "Tag",
  "general.no-rates-available-for-selected-dates": "Keine Tarife für die ausgewählten Tage verfügbar.",
  "general.must-select-passengers": "Wählen Sie Menge und Fahrgäste in mindestens einer Fahrgastkategorie aus.",
  "upselling.no-availability": "Diese Option ist derzeit für Ihren Aufenthalt nicht verfügbar.",
  "general.payment-method": "Zahlungsmethode",
  "general.select-passengers": "Passagiere auswählen",
  "general.select-passenger": "Passagier auswählen",

  "days.sunday": "Sonntag",
  "days.monday": "Montag",
  "days.tuesday": "Dienstag",
  "days.wednesday": "Mittwoch",
  "days.thursday": "Donnerstag",
  "days.friday": "Freitag",
  "days.saturday": "Samstag",

  "public_cart.hours-label": "Öffnungszeiten",
  "public_cart.no-available-hours": "Keine verfügbaren Stunden",
  "CHECKINS_FOUND_NONE_VALID": "Die Buchung ist noch nicht für den Check-in verfügbar. Bitte versuchen Sie es am Anreisetag erneut",
  "CHECKINS_FOUND_MORE_THAN_ONE_VALID": "Es gab ein Problem beim Finden der Buchung nach Zimmer. Bitte versuchen Sie es mit dem Buchungscode",
  "CHECKINS_FOUND_NONE_LASTNAME_VALID": "Die Buchung konnte nicht gefunden werden",
  "kiosk.welcome.subtitle": "Check-in erfolgreich abgeschlossen",
  "kiosk.room": "Zimmer",
  "kiosk.checkin": "Check-in",
  "kiosk.checkout": "Check-out",
  "kiosk.download_app": "Scannen um auf zusätzliche Dienste des Hotels zuzugreifen",
  "kiosk.scan_qr": "Scannen Sie den QR-Code, um auf zusätzliche Dienste zuzugreifen",
  "kiosk.generating_qr": "QR-Code wird generiert...",
  "kiosk.redirect_warning": "Sie werden in {seconds} Sekunden weitergeleitet...",
  "kiosk.go_to_identify": "Finalisieren", 
  "kiosk.logout.title": "Abmelden aus Kiosk",
  "checkin.document-info": "Dokumentinformationen",
  "checkin.personal-info": "Personeninformationen",
  "checkin.location": "Standort",
  "kiosk.back": "Zurück",
  "kiosk.login.title": "Geben Sie Ihre PIN ein",
  "kiosk.login.description": "Bitte geben Sie den Zugriffscode ein, um fortzufahren",
  "kiosk.login.button_access": "Zugang",
  "kiosk.login.button_loading": "Wird geladen...",
  "kiosk.login.error_empty": "Bitte geben Sie die PIN ein",
  "kiosk.login.error_invalid": "Ungültige PIN. Versuchen Sie erneut.",
  "kiosk.login.error_process": "Fehler beim Anmelden. Versuchen Sie erneut.",
  "kiosk.login.copyright": "© {year} {hotel}. Alle Rechte vorbehalten.",
  "request.item-out-of-hours": "Produkt nicht verfügbar in dieser Zeit",
  "kiosk.login.pin": "PIN eingeben",
  "kiosk.logout.confirm": "Geben Sie Ihre PIN ein, um sich abzumelden aus Kiosk",
  "kiosk.receiving-info": "Informationen werden empfangen...",
  "kiosk.inactivity-warning-title": "Sind Sie noch da?",
  "kiosk.inactivity-warning-message": "Sie waren inaktiv. Wenn Sie nicht in den nächsten Sekunden antworten, wird Ihre Sitzung automatisch beendet.",
  "kiosk.inactivity-countdown": "Sitzung wird beendet in",
  "kiosk.inactivity-stay": "Ja, fortfahren",
  "kiosk.inactivity-logout": "Nein, abmelden"
};
